import './vendor/modernizr';

import { AnimateObserver } from './lib/animate-observer';
import { Trigger } from './lib/trigger';
import Plyr from 'plyr';
import { Turnstile } from './lib/turnstile';

const player = new Plyr( '.js-player' );

const animate = new AnimateObserver();
animate.init();

const trigger = new Trigger();
trigger.init();

if ( document.querySelector( '#autocomplete' ) ) {
    import('./lib/autocomplete').then( module => {
        const autocomplete = new module.Autocomplete();
        autocomplete.init();
    });
}

if ( document.querySelector( '.js-instant-search' ) ) {
    // import module for side effects
    import('./lib/instant-search').then( module => {
        const instantSearch = new module.InstantSearch();
        instantSearch.init();
    } );
}

if ( document.querySelector( '.js-modal' ) ) {
    // import module for side effects
    import('./lib/modal').then( module => {
        const modal = new module.Modal();
        modal.init();
    } );
}


if ( document.querySelector( '.js-slider' ) ) {
    // import module for side effects
    import('./lib/slider').then( module => {
        const slider = new module.Slider()
        slider.init();
    } );
}

if ( document.querySelector( '.js-datepicker' ) ) {
    // import module for side effects
    import('./lib/datepicker').then( module => {
        const datepicker = new module.DatePicker();
        datepicker.init();
    } );
}

if ( document.querySelector( '.js-counter' ) ) {
    // import module for side effects
    import('./lib/counter').then( module => {
        const counter = new module.Counter();
        counter.init();
    } );
}
if ( document.querySelector( '.js-turnstile' ) ) {
    import('./lib/turnstile').then( module => {
        const turnstile = new module.Turnstile();
        window.onloadTurnstileCallback = function() {
            turnstile.init()
        }
    } );
}

if ( document.querySelector( '.c-map, .js-map' ) ) {
    // import module for side effects
    import('google-maps-api-loader').then( module => {

        const loader = module.default( {
            version: 'weekly',
            libraries: [],
            apiKey: 'AIzaSyAXMoLePY7Nkhj9RlsEcI0FGx0QZpXjG_E',
        } ).then( ( google ) => {

            if ( document.querySelector( '.js-map' ) ) {
                import('./lib/map').then( module => {
                    const maps = new module.Maps( google );

                    maps.init();
                } );
            }

            if ( document.querySelector( '#locator_map' ) ) {
                import('./lib/locator-map').then( module => {
                    const locatorMap = new module.LocatorMap( google );
                    locatorMap.init();
                } );
            }

        } );
    } );
}
